import { useEffect } from "react";
import { Nav } from "@/components/site/Nav";
import { startTracking } from "@/lib/tracker";
import { Hero } from "@/components/site/Hero";
import { ValueProp } from "@/components/site/ValueProp";
import { Learn } from "@/components/site/Learn";
import { HowItWorks } from "@/components/site/HowItWorks";
import { About } from "@/components/site/About";
import { FAQ } from "@/components/site/FAQ";
import { FinalCTA } from "@/components/site/FinalCTA";
import { Footer } from "@/components/site/Footer";
import { BookingSection } from "@/components/booking/BookingSection";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";

export default function Landing() {
  useEffect(() => {
    return startTracking();
  }, []);

  return (
    <div className="bg-[#F5F7FA]" data-testid="landing-page">
      <Nav />
      <main>
        <Hero />
        <ValueProp />
        <Learn />
        <HowItWorks />
        <About />
        <BookingSection />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
